import { render, staticRenderFns } from "./Scene11.vue?vue&type=template&id=12428e08&scoped=true"
import script from "./Scene11.vue?vue&type=script&lang=js"
export * from "./Scene11.vue?vue&type=script&lang=js"
import style0 from "./Scene11.vue?vue&type=style&index=0&id=12428e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12428e08",
  null
  
)

export default component.exports